import { useEffect, useState } from 'react';
import { TID } from '@/lib/testIds';
import { Menu, X, ArrowUpRight } from 'lucide-react';

const links = [
  { href: '#services', label: 'Services', testid: TID.nav.linkServices },
  { href: '#approach', label: 'Approach', testid: TID.nav.linkApproach },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      data-testid={TID.nav.root}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'backdrop-blur-xl bg-ink/85 border-b border-white/5'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid={TID.nav.brand}
          aria-label="Home"
          className="inline-flex items-center h-8 w-8"
        >
          <span className="sr-only">Home</span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="text-[13px] font-medium text-text/85 hover:text-ember transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid={TID.nav.ctaTalk}
          className="hidden md:inline-flex items-center gap-2 btn-ember rounded-full px-5 py-2.5 text-[12px] font-semibold uppercase tracking-[0.14em]"
        >
          Get in Touch
          <ArrowUpRight size={14} />
        </a>

        <button
          type="button"
          data-testid={TID.nav.menuToggle}
          onClick={() => setOpen((o) => !o)}
          className="md:hidden p-2 -mr-2 text-text"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-ink/95 backdrop-blur-lg">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`${l.testid}-mobile`}
                className="font-display text-2xl text-text hover:text-ember"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid={`${TID.nav.ctaTalk}-mobile`}
              className="mt-2 inline-flex items-center gap-2 btn-ember rounded-full px-5 py-3 text-[12px] uppercase tracking-[0.14em] w-max font-semibold"
            >
              Get in Touch <ArrowUpRight size={14} />
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
